<template>

  <div>
    <form :id="formId">
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.client.startAddress')}}:</div>
              <input type="hidden" name="id" v-model="client.id"/>
              <ejs-textbox
                class="e-input e-input-group"
                :id="this.baseType+'startAddress'"
                name="startAddress"
                v-model="client.startAddress"
                maxlength="20"
                :placeholder="$t('Security.placeholder.startAddress')"
                :blur='startAddressVerif'
              />
            </div>
            <div class="error"></div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.client.endAddress')}}:</div>
              <ejs-textbox
                class="e-input e-input-group"
                :id="this.baseType+'endAddress'"
                name="endAddress"
                v-model="client.endAddress"
                maxlength="20"
                :placeholder="$t('Security.placeholder.endAddress')"
                :blur='endAddressVerif'
              />
            </div>
            <div class="error"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
 import { EventBus } from "../../../plugins/eventBus";
export default {
  name: 'clientOption',
  props: {
    baseType: String
  },
  data () {
    return {
      formId: this.baseType+'clientForm',
      formValidator: '',
      client: {
        id: '',
        startAddress: '',
        endAddress: ''
      },
      validateOptions: {
        customPlacement: function (inputElement, errorElement) {
          inputElement = inputElement.closest('.form-group').querySelector('.error');
          inputElement.parentElement.appendChild(errorElement);
        },
        rules: {
          "startAddress": {
            required: [true, `${this.$t('Security.client.startAddress')}`],
            regex: ['^(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])$',`${this.$t('Security.validate.ip')}`],
          },
          'endAddress': {
            required: [true, `${this.$t('Security.client.endAddress')}`],
            regex: ['^(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])$',`${this.$t('Security.validate.ip')}`],
          },
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    startAddressVerif(){
      var tempIp = this.client.startAddress;
      //判断IP是IPV4还是IPV6
      if(tempIp.indexOf(':') !=-1){//IPV6分支
        this.formValidator.removeRules("startAddress");
        this.formValidator.addRules("startAddress", {
          required: [true, `${this.$t('Security.client.startAddress')}`],
          regex: ['^\s*((([0-9A-Fa-f]{1,4}:){7}(([0-9A-Fa-f]{1,4})|:))|(([0-9A-Fa-f]{1,4}:){6}(:|((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})|(:[0-9A-Fa-f]{1,4})))|(([0-9A-Fa-f]{1,4}:){5}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(([0-9A-Fa-f]{1,4}:){4}(:[0-9A-Fa-f]{1,4}){0,1}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(([0-9A-Fa-f]{1,4}:){3}(:[0-9A-Fa-f]{1,4}){0,2}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(([0-9A-Fa-f]{1,4}:){2}(:[0-9A-Fa-f]{1,4}){0,3}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(([0-9A-Fa-f]{1,4}:)(:[0-9A-Fa-f]{1,4}){0,4}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(:(:[0-9A-Fa-f]{1,4}){0,5}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})))(%.+)?\s*$',`${this.$t('Security.validate.ip')}`],
        })
      }else{//IPV4分支
        this.formValidator.removeRules("startAddress");
        this.formValidator.addRules("startAddress", {
          required: [true, `${this.$t('Security.client.startAddress')} `],
          regex: ['^(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])$',`${this.$t('Security.validate.ip')}`],
        })
      }
    },
    endAddressVerif(){
      var tempIp = this.client.endAddress ;
      //判断IP是IPV4还是IPV6
      if(tempIp.indexOf(':') !=-1){//IPV6分支
        this.formValidator.removeRules("endAddress");
        this.formValidator.addRules("endAddress", {
          required: [true, `${this.$t('Security.client.endAddress')}`],
          regex: ['^\s*((([0-9A-Fa-f]{1,4}:){7}(([0-9A-Fa-f]{1,4})|:))|(([0-9A-Fa-f]{1,4}:){6}(:|((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})|(:[0-9A-Fa-f]{1,4})))|(([0-9A-Fa-f]{1,4}:){5}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(([0-9A-Fa-f]{1,4}:){4}(:[0-9A-Fa-f]{1,4}){0,1}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(([0-9A-Fa-f]{1,4}:){3}(:[0-9A-Fa-f]{1,4}){0,2}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(([0-9A-Fa-f]{1,4}:){2}(:[0-9A-Fa-f]{1,4}){0,3}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(([0-9A-Fa-f]{1,4}:)(:[0-9A-Fa-f]{1,4}){0,4}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(:(:[0-9A-Fa-f]{1,4}){0,5}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})))(%.+)?\s*$',`${this.$t('Security.validate.ip')}`],
        })
      }else{//IPV4分支
        this.formValidator.removeRules("endAddress");
        this.formValidator.addRules("endAddress", {
          required: [true, `${this.$t('Security.client.endAddress')}`],
          regex: ['^(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])$',`${this.$t('Security.validate.ip')}`],
        })
      }
    },
    init(id) {
      if (!!id) {
        const url = '/lte/ems/client/findById';
        let That = this;
        this.axios.get(url, {params: {id: id}}).then(response => {
          const result = response.data;
          That.client.id = result.id;
          That.client.startAddress = result.startAddress;
          That.client.endAddress = result.endAddress;
        });
      }
      this.formValidator = new FormValidator('#'+this.formId, this.validateOptions);
    },
    validation() {

      let result = true;
      result = this.formValidator.validate();
      let start_ip_arr = this.client.startAddress.split(".");
      let end_ip_arr = this.client.endAddress.split(".");
      let id = this.baseType+'endAddress';
      for (let index=0; index < 4; index++) {
        let s_i = start_ip_arr[index];
        let e_i = end_ip_arr[index];
        if (index < 3) {
          if (s_i != e_i) {
            this.eventEmit('error', `${this.$t('Security.validate.addressRangeErr')}`);
         
            result = false;
            break;
          }
        } else if (parseInt(s_i,10) > parseInt(e_i,10)) {
           this.eventEmit('error', `${this.$t('Security.validate.addressCompareErr')}`);
         
    
          result = false;
          break;
        } else {
           
      
        }
      }
      return result;
    },
      eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content})
      },
    getParam() {
      let param = {
        startAddress: this.client.startAddress,
        endAddress: this.client.endAddress
      }
      if (!!this.client.id) {
        param['id'] = this.client.id;
      }
      return param;
    },
   
  }
}
</script>
